import type { Size } from '@ui/types/dialog'

const sizeMap: Record<string, string> = {
  sm: 'size-5',
  md: 'size-6',
  lg: 'size-7',
  xl: 'size-8',
  ['2xl']: 'size-16',
  ['3xl']: 'size-24',
  ['4xl']: 'size-32'
}

export const useSize = (size: Size = 'md') => sizeMap[size] || (sizeMap.md as string)
